<template>
  <div class="completerecords">
    <Tab title="详情" />
    <loading v-if="isLoading"></loading>
    <div class="completerecords-one">
      <div class="completerecords-one-lfet">
        <span>{{ titleName }}金额</span>
      </div>
      <div class="completerecords-one-right">
        <span>
          ¥
          <span class="right-twoSpan">{{ commodityList.totalAmount }}</span>
        </span>
      </div>
    </div>
    <div
      class="completerecords-two"
      v-for="(item, index) in commodityList.paymentGoodsList"
      :key="index"
    >
      <div class="completerecords-two-left">
        <img :src="item.productNormsImg" alt />
      </div>
      <div class="completerecords-two-right">
        <div class="completerecords-two-right-one">
          <span>{{ ellipsis }}</span>
          <span>(货号:{{ item.artNo }})</span>
        </div>
        <p>
          <span class="right-one-span">{{ item.productNormsName }}</span>
        </p>
        <div class="completerecords-two-right-two">
          <p>
            ¥
            <span class="completerecords-span">{{ item.costPrice }}</span>
            <span class="completerecords-TwoSpan">x{{ item.number }}</span>
          </p>
          <p class="right-p" v-if="id == '1'" @click="onClickEdit(item, index)">
            <span>修正数量</span>
          </p>
        </div>
      </div>
    </div>
    <div class="completerecords-three">
      <div class="completerecords-three-one">
        <span>订单号：</span>
        <span>{{ commodityList.serialNumber }}</span>
      </div>
      <div v-if="moneyState">
        <vForthe :commodityList="commodityList" />
      </div>

      <div v-if="refundOfState" style="margin-top: 12px">
        <vAmountOf :commodityList="commodityList" />
      </div>
    </div>
    <div class="completerecords-four">
      <div class="completerecords-four-left">
        <span>商户信息</span>
      </div>
      <div class="completerecords-four-right">
        <p>{{ commodityList.sellerName }}</p>
        <div class="completerecords-four-right-TwoP">
          <img src="../../../assets/imgage/icon_phone.png" alt />
          <span>{{ commodityList.phone }}</span>
        </div>
      </div>
    </div>
    <div v-if="refundOfState">
      <div class="completerecords-four">
        <div class="completerecords-four-left">
          <span>退款信息</span>
        </div>
        <div class="completerecords-four-right">
          <p>{{ commodityList.contacts }}</p>
          <div class="completerecords-four-right-TwoP">
            <img src="../../../assets/imgage/icon_card.png" alt />
            <span>{{ commodityList.bankAccountNum }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="completerecords-footer">
      <span>
        待结算金额
        <span class="footer-span">¥{{ commodityList.totalAmount }}</span>
      </span>
      <van-button
        class="footer-span-button"
        v-preventReClick
        @click.prevent="onclickSumbit"
        >{{ id != 1 ? "我已退款" : "结算" }}</van-button
      >
    </div>
    <!-- 修改数量 -->
    <div v-if="editState">
      <vEdit
        :commodityData="commodityData"
        @onClickOpen="onClickOpen"
        @onClickClose="cancel"
      />
    </div>
  </div>
</template>
<script>
import {
  getSettleApply,
  getSupplierRefunded,
  getDetail,
  getModify,
  getSupplierpage,
} from "api/index/api";
import Loading from "base/loading/loading";
import { Toast } from "vant";
import Tab from "base/tab/tab";
import vEdit from "./edit"; //修改数量
import vAmountOf from "./amountOf"; //退款中
import vForthe from "./forthe"; //待结算
import Message from "base/message/message";

const message = new Message();

export default {
  components: {
    Tab,
    vEdit,
    Loading,
    vAmountOf,
    vForthe,
  },
  data() {
    return {
      isLoading: true, //加载动画
      totalPrices: 0, //总价
      editState: false, //修改数量状态
      refundOfState: false, //待退回
      moneyState: false, //待结算
      titleName: "", //完成状态
      typesData: "", // 交易种类
      ellipsis: null, //显示多少字符
      commodityData: "",
      moneyData: 0, //待结算金额
      //订单商品
      commodityList: [],
    };
  },
  created() {
    this.isLoading = true;
    this.getPayment()
      .then(() => {
        // 待结算金额
        let f = Math.round(this.commodityList.totalAmount * 100) / 100;
        let s = f.toString();
        let rs = s.indexOf(".");
        if (rs < 0) {
          rs = s.length;
          s += ".";
        }
        while (s.length <= rs + 2) {
          s += "0";
        }
        // console.log(s,'sssss')
        // this.totalAmount = s;
        this.totalAmount = this.commodityList.totalAmount;
        this.titleName = this.commodityList.statusName;
        this.id = this.commodityList.status;
        if (this.id == "5") {
          this.refundOfState = true;
        }
        if (this.id == "1") {
          this.moneyState = true;
        }
        // 限制title显示字数
        this.commodityList.paymentGoodsList.forEach((item, index) => {
          if (item.productName.length > 17) {
            // 限制字数17个字
            this.ellipsis = item.productName.slice(0, 20) + "...";
          } else {
            this.ellipsis = item.productName.slice(0, 20);
          }
        });
        this.sunTotalAmount();
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    // 详情接口
    getPayment() {
      const { serialNumber, sellerId, status } = this.$route.query;
      return getDetail({ serialNumber, sellerId, status }).then((res) => {
        this.commodityList = res;
      });
    },
    //供应商端单订单结算
    getApply() {
      let params = {
        serialNumber: this.commodityList.serialNumber,
        sellerId: this.commodityList.sellerId,
        status: this.commodityList.status,
      };
      getSettleApply(params).then((res) => {
        this.isLoading = true;
        message.show("结算成功");
        // Toast.success("结算成功");
        this.$router.push({
          path: "/order",
        });
      });
    },
    // 我已退款
    getRefunded() {
      let params = {
        serialNumber: this.commodityList.serialNumber,
        sellerId: this.commodityList.sellerId,
        status: this.commodityList.status,
      };
      getSupplierRefunded(params).then((res) => {
        this.isLoading = true;
        message.show("退款成功");
        // Toast.success("退款成功");
        this.$router.push({
          path: "/order",
        });
      });
    },
    onclickSumbit() {
      if (this.id == "1") {
        this.getApply();
      }
      if (this.id == "5") {
        this.getRefunded();
      }
    },
    // 弹窗确定按钮
    onClickOpen(item) {
      if (item > 0) {
        this.commodityData.number = item; // 修改完的总数
        this.sunTotalAmount();
        this.getModification();
      }
      this.editState = false;
    },
    // 修改货款
    getModification() {
      let params = {
        number: this.commodityData.number,
        id: this.commodityData.id,
      };
      getModify(params).then((res) => {});
    },
    // 计算总金额
    sunTotalAmount() {
      this.commodityList.totalAmount = 0;
      this.commodityList.paymentGoodsList.map((i) => {
        this.commodityList.totalAmount +=
          Number(i.number) * Number(i.costPrice);
      });
    },
    // 弹窗关闭按钮
    cancel() {
      this.editState = false;
    },
    // 修改数量
    onClickEdit(item, index) {
      this.editState = true;
      this.commodityData = item;
    },
  },
};
</script>
<style lang="scss" scoped>
.completerecords {
  padding-top: 100px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background: #f6f7fb;
  .completerecords-one {
    padding: 55px 30px;
    background: linear-gradient(138deg, #f5755e 0%, #e84031 100%);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .completerecords-one-lfet span {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }

    .completerecords-one-right {
      & > span:nth-child(1) {
        font-size: 26px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #ffffff;
      }

      .right-twoSpan {
        font-size: 46px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #ffffff;
      }
    }
  }

  .completerecords-two {
    padding: 30px 29px 30px 31px;
    display: flex;
    // justify-content: space-between;
    background: #ffffff;
  }

  .completerecords-two-left {
    width: 170px;
    height: 170px;
  }

  .completerecords-two-left img {
    width: 170px;
    height: 170px;
  }

  .completerecords-two-right {
    margin-left: 32px;
    width: 100%;

    & > p {
      // display: inline-block;
      // border: 1px solid red;
      // padding: 30px 40px;
    }

    .completerecords-two-right-one {
      position: relative;
    }

    .completerecords-two-right-one span:nth-child(1) {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      height: 72px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 36px;
    }

    .completerecords-two-right-one span:nth-child(2) {
      position: absolute;
      right: 15px;
      top: 40px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 36px;
    }

    .completerecords-two-right-two {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      & > p {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .completerecords-span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      .completerecords-TwoSpan {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #c7c7c7;
      }

      .right-p {
        width: 150px;
        border-radius: 26px;
        border: 1px solid #cacaca;
        padding: 8px 0;
        text-align: center;

        & > span {
          display: inline-block;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }

  .completerecords-two-right p:nth-child(2) {
    border-radius: 6px;
    margin-top: 11px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 30px;
    .right-one-span {
      display: inline-block;
      background: #f6f6f6;
      padding: 0 13px 0 8px;
      color: #999999;
    }
  }

  .completerecords-three {
    margin-top: 12px;
    padding: 30px 30px 20px 34px;
    background: #ffffff;

    .completerecords-three-one {
      display: flex;
      justify-content: space-between;
      align-content: center;
    }

    .completerecords-three-one span:nth-child(1) {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 37px;
    }

    .completerecords-three-one:nth-child(even) {
      margin: 24px 0;
    }

    .completerecords-three-one span:nth-child(2) {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 37px;
    }
  }

  .completerecords-four {
    margin-top: 12px;
    padding: 20px 30px 20px 34px;
    display: flex;
    justify-content: space-between;
    background: #ffffff;
  }

  .completerecords-four-left {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .completerecords-four-right {
    text-align: right;

    & > p {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }

    .completerecords-four-right-TwoP {
      margin-top: 12px;

      & > img {
        width: 20px;
        height: 20px;
        vertical-align: middle;
      }

      & > span {
        display: inline-block;
        vertical-align: middle;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }

  .completerecords-footer {
    position: fixed;
    width: 100%;
    padding: 18px 30px 18px 35px;
    background: #ffffff;
    bottom: 0;
    text-align: right;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > span:nth-child(1) {
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    .footer-span {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #f24646;
      margin-left: 19px;
    }

    .footer-span-button {
      display: inline-block;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      background: linear-gradient(90deg, #f5755e 0%, #e84031 100%);
      border-radius: 40px;
      padding: 22px 63px 21px 63px;
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/completeRecords/details/sunRefund.vue